exports.isatty = function isatty() {
  return true;
};

exports.getWindowSize = function getWindowSize() {
  if ('innerHeight' in global) {
    return [global.innerHeight, global.innerWidth];
  }
  // In a Web Worker, the DOM Window is not available.
  return [640, 480];
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/lib/browser/tty.js
 ** module id = 60
 ** module chunks = 1
 **/